import { apiGet, apiToken } from "./requests";

export const getPolicies = () => {
  let path = "legal-policies/";
  return apiGet(path);
};

export const createPolicies = (data) => {
  let path = "legal-policies/";
  return apiToken(data, path, "post");
};

export const updatePolicies = (id, data) => {
  console.log(data);
  console.log(id);
  let path = "legal-policies/" + id;
  return apiToken(data, path, "patch");
};

export const deletePolicies = (id) => {
  let path = "legal-policies/" + id;
  return apiToken({}, path, "delete");
};
